import type { PublicSlotKey } from '@/apilib';
import type { QuickEditApi } from './quickEditApi';

export const QuickEditApiKey: PublicSlotKey<QuickEditApi> = {
  name: 'QuickEditApi',
  public: true,
};
